import React, { useCallback, useState } from "react";
import { ArrowDownLongIcon, Body2, Button, Dialog } from "@activecollab/components";
import { t } from "i18next";
import PropTypes from "prop-types";
import { useAddTaskSplits } from "~/repository/useTaskSplits";
import Angie from "~/utils/angie";

const TaskSplitDialog = ({ open, taskId, onConfirm, onSuccess, onCancel, context = "workload" }) => {
  const useAddTaskSplitsMutation = useAddTaskSplits(taskId);
  const [btnDisabled, setBtnDisabled] = useState(false);

  const onSplitTask = useCallback(() => {
    setBtnDisabled(true);
    if (typeof onConfirm === "function") {
      onConfirm();
    }
    useAddTaskSplitsMutation.mutate(null, {
      onSuccess: () => {
        if (typeof onSuccess === "function") {
          onSuccess();
        }
        setBtnDisabled(false);
      },
      onError: () => {
        setBtnDisabled(false);
      },
    });
  }, [onConfirm, onSuccess, useAddTaskSplitsMutation]);

  return (
    <Dialog
      enableBackgroundClick
      open={open}
      onClose={onCancel}
    >
      <Dialog.Title>{t("Split Time Estimation")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content className="tw-flex tw-flex-col tw-gap-4">
        <Body2>
          {t(
            "Split the time estimate to specify exactly how many hours the assignee should work on the task each day."
          )}
        </Body2>
        {context !== "sidebar" ? (
          <>
            <Body2>{t("Here's an example:")}</Body2>
            <div className="tw-bg-[var(--color-theme-200)] tw-rounded-[16px] tw-px-3 tw-flex tw-flex-col tw-items-center sm:tw-flex-row tw-gap-4 tw-justify-between tw-pt-[24px] tw-pb-[24px] tw-w-full tw-border tw-border-solid tw-border-[var(--color-theme-300)]">
              <img
                src={`${Angie.assets_url}/system/images/workload/split-task-explanation-1.png`}
                alt={t("Task Explanation")}
                className="tw-h-[90px] tw-w-[200px]"
              />
              <ArrowDownLongIcon className="tw-rotate-0 sm:tw--rotate-90" />
              <img
                src={`${Angie.assets_url}/system/images/workload/split-task-explanation-2.png`}
                alt={t("Task Explanation")}
                className="tw-h-[90px] tw-w-[200px]"
              />
            </div>
          </>
        ) : null}
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions className="tw-flex tw-gap-3">
        <Button
          type="button"
          onClick={onSplitTask}
          disabled={btnDisabled}
        >
          {t("Split")}
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
        >
          {t("Cancel")}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

TaskSplitDialog.propTypes = {
  open: PropTypes.bool,
  taskId: PropTypes.number,
  onConfirm: PropTypes.func,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
  context: PropTypes.string,
};

export default TaskSplitDialog;
